module.exports = __webpack_public_path__ + "img/second-bg.3cc26c1d.png";